<template>
	<div>
		<egranty-section-divider
			text="Udostępnione projekty/wnioski placówek"
		/>
		<div v-for="agencyProjectBasicData in allowedAgencyProjectsData" :key="agencyProjectBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{agencyProjectBasicData.agencyProjectCode}} &emsp;
						{{agencyProjectBasicData.title}}</h3>
					<egranty-icon-button
						label="Podgląd"
						icon="assignment"
						@click="() => viewAgencyProject(agencyProjectBasicData)"
					/>
				</v-layout>
			</v-card>
		</div>
	</div>
</template>

<script>
	import {AgencyProject} from "../../../api/generated/AgencyProject";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "AllowedAgencyProjectsView",
		components: {EgrantyIconButton, EgrantySectionDivider},
		data () {
			return {
				allowedAgencyProjectsData: []
			};
		},

		methods: {
			viewAgencyProject (agencyProjectBasicData) {
				this.$router.openInNewTab("/view/agency-contest/" + agencyProjectBasicData.contestId + "/project/" + agencyProjectBasicData.agencyId + "/" + agencyProjectBasicData.id);
			}
		},

		mounted () {
			AgencyProject.getAllowedBasicData(this, response => this.allowedAgencyProjectsData = response);
		}
	};
</script>

<style scoped>

</style>